// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_loadable_component_dist_loadable_esm_js-node_modules_reduxjs_toolkit_dis-4f01cf"], () => (__webpack_require__("./src/js/app.tsx")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
